import { use, useCallback } from 'react'

import { fetchConversationMessages } from '@app/api'
import { ChatContext } from '@app/context'
import { MESSAGES_LIST_SIZE } from '@app/hooks'
import { ConversationItem } from '@app/models'

export const useChatTranslations = () => {
  const { dispatch } = use(ChatContext)

  const fetchTranslations = useCallback(
    async (conv: ConversationItem) => {
      dispatch({ type: 'FETCH_MESSAGES_START', payload: conv.id })

      try {
        const { messages } = await fetchConversationMessages(
          conv.id,
          null,
          MESSAGES_LIST_SIZE,
          new AbortController().signal
        )

        dispatch({
          type: 'FETCH_TRANSLATED_MESSAGES_SUCCESS',
          payload: {
            conversationId: conv.id,
            messages,
          },
        })
      } catch (error) {
        console.error(error)
        dispatch({ type: 'FETCH_MESSAGES_ERROR', payload: conv.id })
      }
    },
    [dispatch]
  )

  return { fetchTranslations }
}
